import React, { useEffect } from 'react'
import LoadingPanel from './loadingPanel';
import OnlineRegisterButton from './onlineRegisterButton';

// import api
import { useGetOnlineCourseInstanceQuery } from '../api/courses';


/**
 * Expanded accordion future online course instance data
 * @param {number} modulePrice - Price per module
 * @param {number} moduleCount - Number of modules in online course
 * @param {number} estCourseTime - total estimated course time to completion
 */
function FutureOnlineCourseInstance({courseRecordId}) {

    // get the future courses with the new RTK query
    // Using a query hook automatically fetches data and returns query values
    // set up refetching so we can bust the cache when accordions are opened and new data is written to WP for open seats and wailists
    const { currentData: onlineCourseCurrentData} = useGetOnlineCourseInstanceQuery(courseRecordId);

    // local variables from online course api call
    // TODO: this should be an array of prices
    const modulePrice = onlineCourseCurrentData?.modulePrice;
    const firstModulePrice = onlineCourseCurrentData?.firstModulePrice > 0 ? onlineCourseCurrentData?.firstModulePrice : 0;
    const moduleCount = onlineCourseCurrentData?.moduleCount;
    const estCourseTime = onlineCourseCurrentData?.estCourseTime;

    // currency formatter
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        // These options are needed to round to whole numbers if that's what you want.
        // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    /**
     * Get the first module cost of the online course
     * @returns JSX
     */
    const getFirstModuleMessage = () => {
        if(firstModulePrice > 0) {
            return;
        } else {
            return <>The first module is available for free.<br/></>;
        }
    }

    /**
     * Get the first module cost of the online course
     * @returns JSX
     */
    const getAdditionalModulesMessage = () => {
        if(firstModulePrice > 0) {
            if(moduleCount === 1) {
                return `${formatter.format(Number(firstModulePrice))}`;
            }else {
                return `Each module is ${formatter.format(Number(firstModulePrice))}`;
            }
        } else {
            return `Each additional module is ${formatter.format(Number(modulePrice))} per module.`;
        }
    }

    /**
     * Get the estimated course time
     * @returns JSX
     */
    const getEstCourseTime = () => {
        if(estCourseTime > 0){
            return <p>Total course time: {estCourseTime} Hours</p>;
        }
    }

    useEffect(() => {
        // console log online course data
        console.log(onlineCourseCurrentData);
    }, [onlineCourseCurrentData]);



    // Component level JSX return statement ******************************************************
    return (
        <>
            {/* if we dont have data and its fetching show the loading panel */}
            {(!onlineCourseCurrentData) &&
                <LoadingPanel loadText="Loading Online Course Details"/>
            }
            {onlineCourseCurrentData &&
                <div className="table-course-list__row responsive-grid rg-align-items-center">
                    <div className="rg-5 rg-sm-12 rg-xs-12">
                        <h4 className="cell-headline">Participant - Digital</h4>
                        <div className="module-cost">
                            <p>
                                {getFirstModuleMessage()}
                                {getAdditionalModulesMessage()}<br/>
                            </p>
                        </div>
                    </div>
                    <div className="rg-3 rg-sm-12 rg-xs-12">
                        <div className="module-and-hours">
                            <p>{`${moduleCount} Module${moduleCount > 1 ? 's' : ''}`}</p>
                            {getEstCourseTime()}
                        </div>
                    </div>
                    <div className="rg-4 rg-sm-12 rg-xs-12">
                        {/* {getRegisterButton()} */}
                        <OnlineRegisterButton courseRecordId={courseRecordId}></OnlineRegisterButton>
                    </div>
                </div>
            }
        </>
    );
}

export default FutureOnlineCourseInstance;